'use client'

import { Link } from '@/navigation'
import { useTranslations } from 'next-intl'
import { Navigation, Autoplay } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import { ArrowRight, ArrowLeft } from 'iconsax-react'

import SpecialistCard from './SpecialistCard'

import type { FC } from 'react'
import type { IFetchedDataRoot, ISpecialistData } from '@/types'

interface IProps {
  isMain?: boolean
  data: IFetchedDataRoot<ISpecialistData>
}

const Specialists: FC<IProps> = ({ isMain = false, data }) => {
  const t = useTranslations('')

  return (
    <div className="container mx-auto px-4 py-[30px] md:py-12">
      <div className="mb-8 grid grid-cols-2 gap-5 md:gap-10">
        <h2 className="col-span-2 md:col-span-1">
          {isMain ? t('OurSpecialistsSection.title') : t('AboutUsSpecialists.title')}
        </h2>
        <div className=" col-span-2 md:col-span-1">
          <p className="mb-6 font-medium text-secondary-dark">
            {isMain ? t('OurSpecialistsSection.description') : t('AboutUsSpecialists.description')}
          </p>
          <div
            className={`flex flex-row gap-3 md:gap-6 ${isMain ? 'justify-between' : 'justify-end'}`}
          >
            {isMain && (
              <Link
                href="/about-us"
                className="btn-primary"
                aria-label={t('Buttons.MoreAboutTheCompany')}
              >
                {t('Buttons.MoreAboutTheCompany')}
              </Link>
            )}
            <div className="flex flex-row gap-3 md:gap-6">
              <button
                className="btn-prev-specialist btn-slider text-2xl"
                aria-label="about company previous"
              >
                <ArrowLeft />
              </button>
              <button
                className="btn-next-specialist btn-slider text-2xl"
                aria-label="about company next"
              >
                <ArrowRight />
              </button>
            </div>
          </div>
        </div>
      </div>
      <Swiper
        loop
        modules={[Navigation, Autoplay]}
        autoplay
        breakpoints={{
          428: { slidesPerView: 1 },
          640: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: 3,
          },
          1024: {
            slidesPerView: 4,
          },
        }}
        spaceBetween={24}
        navigation={{ prevEl: '.btn-prev-specialist', nextEl: '.btn-next-specialist' }}
      >
        {[...data.results, ...data.results].map((specialist, i) => (
          <SwiperSlide key={specialist.slug + i} style={{ width: 'fit-content' }}>
            <SpecialistCard {...specialist} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
}

export default Specialists
